import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';

const EstatePlanStatusStepLayout = () => {
  const {
    resource,
    onSubmit,
    saving,
  } = useMetaLayoutContext();

  const EstatePlanStatusStepImage = resource.withRelationship(
    fr.relationships.image.name,
    (rel) => (
      <ImageRel relationship={rel} width={'100%'} />
    ),
    () => null,
  );

  return (
    <FDBox alignSelf={'center'} margin={4} paddingY={1}>
      <FDStack direction={'column'} spacing={3}>
        {EstatePlanStatusStepImage}
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'subtitle'} />
        <MetaControlField attr={'statusSelection'} />
        <FDBox alignSelf={'center'}>
          <FDPrimaryActionButton
            onClick={onSubmit}
            loading={saving}
            disabled={resource.attr('statusSelection') === ''}
            {...dataAttrs('estate-planning-status-continue-button')}
            label={'Continue'}
            size="md"
            isFullWidth={false}
          />
        </FDBox>
      </FDStack>
    </FDBox>
  );
};

EstatePlanStatusStepLayout.defaultProps = {
};

EstatePlanStatusStepLayout.propTypes = {
};

export default EstatePlanStatusStepLayout;
